export default {
    state: {
        selectedSideBar: "newLicenseUnassigned",
    }
}